import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';
import {BillingPlanPriceResponse} from '../types';

export type EnterprisePricesSuccessResponse =
    Api.Response.Success<BillingPlanPriceResponse>;

export type EnterprisePricesErrorResponse = Api.Response.Failure<string>;
type GetEnterprisePricesProps = {
    onError: (error: EnterprisePricesErrorResponse) => void;
    searchParams?: {[k: string]: string | number};
};

const useGetEnterprisePrices = ({
    onError,
    searchParams,
}: GetEnterprisePricesProps): UseQueryResult<
    EnterprisePricesSuccessResponse,
    EnterprisePricesErrorResponse
> => {
    const locale = useLocale();

    return useQuery(
        ['getEnterpriseSubscription', searchParams],
        () =>
            request({
                locale,
                params: searchParams,
                uri: '/api/billing/plan/price/enterprise/',
            }),
        {
            onError,
            refetchOnWindowFocus: false,
            retry: 2,
        },
    );
};

export default useGetEnterprisePrices;
